
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("ge1Lf", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => (parcelRequire("jojgm")).default);
$parcel$export(module.exports, "LOZENGE", () => $a4c5fe4dcf7753af$export$44f42916442b37c3);
$parcel$export(module.exports, "INLINE", () => $a4c5fe4dcf7753af$export$1ff9623b26415f8);
$parcel$export(module.exports, "NORMAL", () => $a4c5fe4dcf7753af$export$eade6b6091579183);
$parcel$export(module.exports, "CHILD_ISSUE_LOZENGE", () => $a4c5fe4dcf7753af$export$797ed91ebb8db1c5);
$parcel$export(module.exports, "useNumberField", () => (parcelRequire("3wves")).useNumberField);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $jojgm = parcelRequire("jojgm");


var $3wves = parcelRequire("3wves");

});
parcelRegister("jojgm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "actionSubject", () => $49da18a2c4ce5982$export$fd8ebf59dd2b58b6);
$parcel$export(module.exports, "default", () => $49da18a2c4ce5982$export$2e2bcd8739ae039);
$parcel$export(module.exports, "LozengeChildNumberFieldContainer", () => $49da18a2c4ce5982$export$e5940b0448e9a6f);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $9XE6b = parcelRequire("9XE6b");

var $4R6GH = parcelRequire("4R6GH");

var $8tf7c = parcelRequire("8tf7c");

var $Fn2Vl = parcelRequire("Fn2Vl");

var $gGpyR = parcelRequire("gGpyR");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");



var $3wves = parcelRequire("3wves");

var $bpos5 = parcelRequire("bpos5");

var $ij436 = parcelRequire("ij436");

var $hXYQI = parcelRequire("hXYQI");
const $49da18a2c4ce5982$export$fd8ebf59dd2b58b6 = 'numberInlineEdit';
var $49da18a2c4ce5982$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { fieldKey: fieldKey, issueKey: issueKey, onCancel: onCancel, onEdit: onEdit, onEscape: onEscape, onConfirm: onConfirm, onEnter: onEnter, onUpdate: onUpdate, onSubmit: onSubmit, onFailure: onFailure, readView: readView, editView: editView, noValueText: noValueText, fieldFocusStyle: fieldFocusStyle, fieldEditStyle: fieldEditStyle, saveField: saveField, ...rest } = props;
    const [isEditing, setIsEditing] = (0, $5uXOq.useState)(false);
    const onSuccess = (newValue)=>{
        onUpdate && onUpdate(newValue);
        setIsEditing(false);
    };
    const [{ value: value, error: error, fieldConfig: fieldConfig }, { saveValue: saveValue, resetError: resetError }] = (0, $3wves.useNumberField)({
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        fieldKey: fieldKey,
        onSuccess: onSuccess,
        onSubmit: onSubmit,
        onFailure: onFailure,
        saveField: saveField
    });
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'number');
    const [updatedValue, setUpdatedValue] = (0, $5uXOq.useState)(value);
    const isFieldEditable = fieldConfig ? fieldConfig.isEditable : false;
    (0, $5uXOq.useEffect)(()=>{
        if (error) setIsEditing(true);
        if (!isEditing) setUpdatedValue(value);
    }, [
        error,
        isEditing,
        value
    ]);
    const save = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        if (updatedValue !== value) saveValue(updatedValue, null, analyticsEvent);
        else setIsEditing(false);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        saveValue,
        updatedValue,
        value
    ]);
    const cancel = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        resetError();
        setIsEditing(false);
        setUpdatedValue(value);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        resetError,
        value
    ]);
    const onCancelRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onCancel && onCancel(analyticsEvent);
    }, [
        onCancel,
        cancel
    ]);
    const onConfirmRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        save(analyticsEvent);
        onConfirm && onConfirm(analyticsEvent);
    }, [
        onConfirm,
        save
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        setIsEditing(true);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onEdit && onEdit(analyticsEvent);
    }, [
        onEdit
    ]);
    const onEscapeRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        cancel(analyticsEvent);
        onEscape && onEscape(analyticsEvent);
    }, [
        onEscape,
        cancel
    ]);
    const onEnterRequest = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onEnter && onEnter(analyticsEvent);
    }, [
        onEnter
    ]);
    const onChange = (0, $5uXOq.useCallback)((event)=>{
        resetError();
        const typedValue = event.target.value === '' ? null : parseFloat(Number(event.target.value).toFixed(3));
        setUpdatedValue(typedValue);
    }, [
        resetError,
        setUpdatedValue
    ]);
    const renderEditView = ()=>editView !== undefined ? editView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bpos5.NumberEdit), {
            defaultValue: updatedValue,
            onChange: onChange,
            type: fieldType,
            isInvalid: !!error
        });
    const renderReadView = ()=>readView !== undefined ? readView : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXYQI.NumberView), {
            isEditable: isFieldEditable,
            value: value,
            setIsEditing: setIsEditing
        });
    let InlineEditContainer = $49da18a2c4ce5982$var$NumberInlineEditContainer;
    if (fieldFocusStyle === (0, $a4c5fe4dcf7753af$export$44f42916442b37c3)) InlineEditContainer = $49da18a2c4ce5982$var$LozengeNumberFieldContainer;
    if (fieldFocusStyle === (0, $a4c5fe4dcf7753af$export$797ed91ebb8db1c5)) InlineEditContainer = $49da18a2c4ce5982$export$e5940b0448e9a6f;
    if (isEditing) {
        if (fieldEditStyle === (0, $a4c5fe4dcf7753af$export$1ff9623b26415f8)) InlineEditContainer = $49da18a2c4ce5982$var$InlineWidthContainer;
    }
    const numberInlineEdit = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8tf7c.ErrorFlag), {
        error: error,
        title: (0, $ij436.default).errorTitle,
        description: (0, $ij436.default).errorMessage
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InlineEditContainer, {
        isEditable: isFieldEditable
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGpyR.FieldInlineEditStateLess), {
        testId: (0, $ea286d2db1e9f268$export$195635d59130784a),
        fieldId: (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? fieldKey : undefined,
        actionSubject: $49da18a2c4ce5982$export$fd8ebf59dd2b58b6,
        isEditable: isFieldEditable,
        isEditing: isEditing,
        readView: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Fn2Vl.ReadViewContainer), null, renderReadView()),
        editView: isFieldEditable ? renderEditView() : null,
        onCancel: onCancelRequest,
        onConfirm: onConfirmRequest,
        onEdit: onEditRequested,
        onEscape: onEscapeRequest,
        onEnter: onEnterRequest,
        ...rest
    })));
    if (fieldFocusStyle !== (0, $a4c5fe4dcf7753af$export$797ed91ebb8db1c5)) return numberInlineEdit;
    return isEditing ? numberInlineEdit : // @ts-expect-error - TS2741 - Property 'hasValue' is missing in type '{ children: Element; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { hasValue: boolean; }, any>>'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InlineEditContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Fn2Vl.ReadViewContainer), null, renderReadView()));
});
// @ts-expect-error - TS2345: Argument of type 'StyledComponentClass'
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49da18a2c4ce5982$var$LozengeNumberFieldContainer = /*#__PURE__*/ (0, $47bDC.default)((0, $Fn2Vl.InlineEditContainer)).withConfig({
    componentId: "ngcazt-0"
})`padding-right:${"var(--ds-space-075, 6px)"};& div[data-read-view-fit-container-width]{background:transparent !important;border:none !important;vertical-align:top;}& button[aria-label='Edit']:focus + div > div:first-child{border:2px solid ${"var(--ds-border-focused, #388BFF)"};border-radius:${"var(--ds-border-radius-300, 12px)"};${'' /* PX values as these are to negate the focus outline offset (implemented as a 2px border) */ } margin-left:-2px;margin-right:-6px;}`;
const $49da18a2c4ce5982$export$e5940b0448e9a6f = /*#__PURE__*/ (0, $47bDC.default)($49da18a2c4ce5982$var$LozengeNumberFieldContainer).withConfig({
    componentId: "ngcazt-1"
})`padding-top:${"var(--ds-space-100, 8px)"};`;
// @ts-expect-error - TS2345: Argument of type 'StyledComponentClass'
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49da18a2c4ce5982$var$InlineWidthContainer = /*#__PURE__*/ (0, $47bDC.default)((0, $Fn2Vl.InlineEditContainer)).withConfig({
    componentId: "ngcazt-2"
})`padding-right:${"var(--ds-space-075, 6px)"};width:68px;margin-right:${"var(--ds-space-negative-075, -6px)"};& [data-ds--text-field--container]{border-color:${"var(--ds-border-focused, #388BFF)"};}`;
// @ts-expect-error - TS2345: Argument of type 'StyledComponentClass'
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $49da18a2c4ce5982$var$NumberInlineEditContainer = /*#__PURE__*/ (0, $47bDC.default)((0, $Fn2Vl.InlineEditContainer)).withConfig({
    componentId: "ngcazt-3"
})`${({ isEditable: isEditable })=>!isEditable ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $47bDC.css)`left:0;padding:${"var(--ds-space-075, 6px)"} 0;${'' /* NonEditableMargin overrides */ } & > div{margin:11px 0 3px ${"var(--ds-space-025, 2px)"};}${0, $Fn2Vl.ReadViewContainer}{margin-left:0;line-height:1;}` : null}`;

});
parcelRegister("8tf7c", function(module, exports) {

$parcel$export(module.exports, "ErrorFlag", () => $b20ca95c735c7779$export$518ba8e0e60f145f);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $LJaTB = parcelRequire("LJaTB");
const $b20ca95c735c7779$export$518ba8e0e60f145f = ({ error: error, title: title, description: description })=>{
    if (!error) return null;
    if (error instanceof (0, $jJZqs.ValidationError)) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessage = error.message || error.errors && error.errors[0] && error.errors[0].error || description;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
            flag: {
                messageId: 'issue-error-flag.flag.warning.issue.fields.components.error-flag.flag.warning',
                messageType: 'transactional',
                type: 'warning',
                title: title,
                description: errorMessage,
                testId: (0, $4R6GH.fg)('relay-migration-issue-fields-number') ? 'issue-error-flag.error-flag.warning' : undefined
            }
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $LJaTB.FlagRenderer), {
        flag: {
            messageId: 'issue-error-flag.flag.error.issue.fields.components.error-flag.flag.error',
            messageType: 'transactional',
            type: 'error',
            title: title,
            description: description,
            testId: (0, $4R6GH.fg)('relay-migration-issue-fields-number') ? 'issue-error-flag.error-flag.error' : undefined
        }
    });
};

});
parcelRegister("LJaTB", function(module, exports) {

$parcel$export(module.exports, "FlagRenderer", () => $2de6889b93863972$export$7c38ebd1f7ca6a5a);

var $hkhmi = parcelRequire("hkhmi");

var $34Vv8 = parcelRequire("34Vv8");
const $2de6889b93863972$export$7c38ebd1f7ca6a5a = (0, $34Vv8.default)((0, $hkhmi.default));

});
parcelRegister("hkhmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2971dd786c0add8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fHfPB = parcelRequire("fHfPB");
class $e2971dd786c0add8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { flagService: flagService, flag: flag } = this.props;
        if (flagService) this.flagId = flagService.showFlag(flag);
    }
    componentWillUnmount() {
        const { flagService: flagService } = this.props;
        if (flagService && this.flagId) flagService.dismissFlag((0, $fHfPB.dismissFlag)(this.flagId));
    }
    render() {
        return null;
    }
}

});



parcelRegister("Fn2Vl", function(module, exports) {

$parcel$export(module.exports, "InlineEditContainer", () => $2060312c94028fa8$export$9f16bbb9a44c7bf6);
$parcel$export(module.exports, "InlineEditContainerExperiment", () => $2060312c94028fa8$export$409c96a6d46b6d0);
$parcel$export(module.exports, "ReadViewContainer", () => $2060312c94028fa8$export$ebb3489b83262b26);
$parcel$export(module.exports, "readOnlyViewContainerSelectorName", () => $2060312c94028fa8$export$dafe48f89a07868a);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $gwIPs = parcelRequire("gwIPs");
/*
 Using calc as this margin negates 2 things:
 - Left displacement which ensures there's more space for the input element that becomes visible on focus.
 - The focus outline offset for the badge (implemented as a 2px border) which is in PX everywhere currently.
 The REM is affected by browser font size settings while PX isn't. So, this ensures the spacing behaves in a consistent manner.
 */ const $2060312c94028fa8$var$MARGIN_LEFT = `calc(${"var(--ds-space-negative-075, -6px)"} - 2px)`;
const $2060312c94028fa8$export$9f16bbb9a44c7bf6 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "q52d93-0"
})`margin-left:${$2060312c94028fa8$var$MARGIN_LEFT};margin-top:${"var(--ds-space-negative-100, -8px)"};padding-right:${"var(--ds-space-100, 8px)"};& div[data-read-view-fit-container-width]{width:100%;min-height:${(0, $gwIPs.gridSize) * 4}px;${({ hasValue: hasValue })=>hasValue ? // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $47bDC.css)`padding:0;` : // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
    (0, $47bDC.css)`padding:${"var(--ds-space-100, 8px)"} 0;`}}`;
const $2060312c94028fa8$export$409c96a6d46b6d0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0x0bf _19pkx0bf _u5f3u2gc _6vgs1osq _1rjezwfg",
            __cmplp.hasValue ? "_osjgidpf _2g9bidpf _alyvidpf _pa3xidpf" : "_osjg1v6z _2g9bidpf _alyv1v6z _pa3xidpf",
            __cmplp.className
        ])
    });
});
const $2060312c94028fa8$export$ebb3489b83262b26 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "q52d93-1"
})({
    wordBreak: 'break-word',
    position: 'relative',
    left: "var(--ds-space-075, 6px)"
});
const $2060312c94028fa8$var$readViewContainerSelectorName = 'jira-issue-field-inline-edit-read-view-container';
const $2060312c94028fa8$export$dafe48f89a07868a = 'jira-issue-field-inline-edit-readonly-view-container';
const $2060312c94028fa8$export$5c18970ef161f5b6 = `[data-component-selector="${$2060312c94028fa8$var$readViewContainerSelectorName}"]`;
const $2060312c94028fa8$export$eab846169c2a4f66 = `[data-component-selector="${$2060312c94028fa8$export$dafe48f89a07868a}"]`;
$2060312c94028fa8$export$ebb3489b83262b26.defaultProps = {
    'data-component-selector': $2060312c94028fa8$var$readViewContainerSelectorName
};
const $2060312c94028fa8$export$646e0a1b0db8be98 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nmz1hna _kqswh2mm _1ltv12x7",
            __cmplp.className
        ])
    });
});
const $2060312c94028fa8$export$3b079ed2709f4949 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gGpyR", function(module, exports) {

$parcel$export(module.exports, "FieldInlineEditStateLess", () => $cca53fa1018295ba$export$9a29c614a3f4aae1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ec0Lk = parcelRequire("ec0Lk");

var $3RTQl = parcelRequire("3RTQl");

var $i0vxP = parcelRequire("i0vxP");

var $4R6GH = parcelRequire("4R6GH");

var $ctrpc = parcelRequire("ctrpc");

var $2gCtH = parcelRequire("2gCtH");

var $54wEF = parcelRequire("54wEF");

var $69oHP = parcelRequire("69oHP");

var $cIZbf = parcelRequire("cIZbf");

var $2OMDV = parcelRequire("2OMDV");
var $bngFq = parcelRequire("bngFq");

var $Fn2Vl = parcelRequire("Fn2Vl");
const $cca53fa1018295ba$export$5af7124b5599afd0 = (0, $2OMDV.AnalyticsEventToProps)('EnterEscapeHandler', {
    onEnter: 'entered',
    onEscape: 'escaped'
})((0, $i0vxP.default));
const $cca53fa1018295ba$export$41b20ce1a1b4f6f1 = (0, $2OMDV.AnalyticsEventToProps)('EscapeHandler', {
    onEscape: 'escaped'
})((0, $i0vxP.default));
const $cca53fa1018295ba$export$bfbc426ae4e1403d = (0, $2OMDV.AnalyticsEventToProps)('EnterHandler', {
    onEnter: 'entered'
})((0, $i0vxP.default));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cca53fa1018295ba$var$FieldContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12jb1r31 _1gjeglyw _qrzw1o36",
            __cmplp.className
        ])
    });
});
const $cca53fa1018295ba$var$NonEditableMargin = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18s81uch",
            __cmplp.className
        ])
    });
});
const $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent = (callback, payload)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(()=>{
        if (typeof callback === 'function') callback(createAnalyticsEvent(payload));
    }, [
        callback,
        createAnalyticsEvent,
        payload
    ]);
};
const $cca53fa1018295ba$var$useCallbackWithAnalyticsEventForEdit = (callback, payload)=>{
    const { fieldId: fieldId, fieldType: fieldTypeFromProps, isInlineEditing: isInlineEditing = false } = payload;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $bngFq.useAnalyticsEvents)();
    const issueKey = (0, $2gCtH.useIssueKey)();
    const pressTrace = (0, $3RTQl.default)('issue.field.inline-edit');
    const fieldIdWithoutAri = (0, $cIZbf.getFieldIdFromAri)(fieldId);
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey || '', fieldIdWithoutAri || '');
    const fieldType = fieldTypeFromProps || (0, $69oHP.getFieldType)(fieldConfig?.value);
    return (0, $5uXOq.useCallback)(()=>{
        (0, $4R6GH.fg)('jiv-20205-more-ufo-tracing') && pressTrace();
        if (fieldIdWithoutAri && fieldType) {
            const event = createAnalyticsEvent({});
            (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldIdWithoutAri, {
                analytics: event,
                attributes: {
                    fieldType: fieldType,
                    isInlineEditing: isInlineEditing
                }
            });
        }
        if (typeof callback === 'function') callback(createAnalyticsEvent(payload));
    }, [
        callback,
        createAnalyticsEvent,
        fieldIdWithoutAri,
        fieldType,
        payload,
        isInlineEditing,
        pressTrace
    ]);
};
function $cca53fa1018295ba$var$FieldInlineEditStateLessInner(props) {
    const { actionSubject: actionSubject = 'fieldInlineEdit', editView: editView, isEditable: isEditable = false, isEditing: isEditing = false, isLabelHidden: isLabelHidden = true, readView: readView, testId: testId, fieldId: fieldId, onCancel: onCancel, onConfirm: onConfirm, onEdit: onEdit, onEditRequested: onEditRequested, onEnter: onEnter, onEscape: onEscape } = props;
    const handleEnter = $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent(onEnter, {
        action: 'entered',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleEscape = $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent(onEscape, {
        action: 'escaped',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleEdit = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    $cca53fa1018295ba$var$useCallbackWithAnalyticsEventForEdit(onEditRequested || onEdit, {
        action: 'focused',
        actionSubject: actionSubject,
        fieldId: fieldId,
        ...props.componentAnalyticsData
    }) // eslint-disable-next-line react-hooks/rules-of-hooks
     : $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent(onEditRequested || onEdit, {
        action: 'focused',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleCancel = $cca53fa1018295ba$var$useCallbackWithAnalyticsEvent(onCancel, {
        action: 'canceled',
        actionSubject: actionSubject,
        ...props.componentAnalyticsData
    });
    const handleConfirm = (0, $5uXOq.useCallback)((_, event)=>{
        if (typeof onConfirm === 'function') onConfirm(event.update({
            action: 'confirmed',
            actionSubject: actionSubject,
            ...props.componentAnalyticsData
        }));
    }, [
        actionSubject,
        onConfirm,
        props.componentAnalyticsData
    ]);
    const renderReadView = typeof readView === 'function' ? readView : ()=>readView;
    const renderEditView = (0, $5uXOq.useMemo)(()=>{
        if (typeof editView === 'function') return editView;
        return ()=>editView;
    }, [
        editView
    ]);
    const renderEditViewWithHandlers = (0, $5uXOq.useCallback)((editProps, ref)=>{
        if (editView === null) return null;
        if (onEnter && onEscape) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$export$5af7124b5599afd0, {
            onEnter: handleEnter,
            onEscape: handleEscape
        }, renderEditView(editProps, ref));
        if (onEnter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$export$bfbc426ae4e1403d, {
            onEnter: handleEnter
        }, renderEditView(editProps, ref));
        if (onEscape) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$export$41b20ce1a1b4f6f1, {
            onEscape: handleEscape
        }, renderEditView(editProps, ref));
        return renderEditView(editProps, ref);
    }, [
        editView,
        onEnter,
        onEscape,
        handleEnter,
        handleEscape,
        renderEditView
    ]);
    const inlineEditProps = {
        defaultValue: 'defaultValue' in props ? props.defaultValue : props.value,
        onConfirm: handleConfirm,
        readView: renderReadView,
        editView: renderEditViewWithHandlers,
        isEditing: isEditing,
        onCancel: handleCancel,
        onEdit: handleEdit,
        isRequired: props.isRequired,
        analyticsContext: props.analyticsContext,
        cancelButtonLabel: props.cancelButtonLabel,
        confirmButtonLabel: props.confirmButtonLabel,
        editButtonLabel: props.editButtonLabel,
        hideActionButtons: 'hideActionButtons' in props ? props.hideActionButtons : props.areActionButtonsHidden,
        keepEditViewOpenOnBlur: 'keepEditViewOpenOnBlur' in props ? props.keepEditViewOpenOnBlur : props.isConfirmOnBlurDisabled,
        label: isLabelHidden === true ? undefined : props.label,
        readViewFitContainerWidth: 'readViewFitContainerWidth' in props ? props.readViewFitContainerWidth : props.isFitContainerWidthReadView,
        startWithEditViewOpen: props.startWithEditViewOpen,
        validate: props.validate
    };
    return isEditable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$var$FieldContainer, {
        "data-testid": testId != null ? `${testId}--container` : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ec0Lk.default), inlineEditProps)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cca53fa1018295ba$var$NonEditableMargin, {
        "data-component-selector": (0, $Fn2Vl.readOnlyViewContainerSelectorName),
        "data-testid": testId != null ? `${testId}--read-only-container` : undefined
    }, renderReadView());
}
const $cca53fa1018295ba$export$9a29c614a3f4aae1 = /*#__PURE__*/ (0, $5uXOq.memo)($cca53fa1018295ba$var$FieldInlineEditStateLessInner);
var $cca53fa1018295ba$export$2e2bcd8739ae039 = $cca53fa1018295ba$export$9a29c614a3f4aae1;

});
parcelRegister("ec0Lk", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c84accef102bc9e$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eNCZ4 = parcelRequire("eNCZ4");

var $4EHpO = parcelRequire("4EHpO");

var $7folp = parcelRequire("7folp");

var $fHpHg = parcelRequire("fHpHg");

var $7rJgC = parcelRequire("7rJgC");

var $cBCgC = parcelRequire("cBCgC");

var $5uae8 = parcelRequire("5uae8");

var $1eXlh = parcelRequire("1eXlh");

var $4P8zB = parcelRequire("4P8zB");
const $3c84accef102bc9e$var$fieldStyles = null;
const $3c84accef102bc9e$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3c84accef102bc9e$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $1eXlh.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $eNCZ4.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$3c84accef102bc9e$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4P8zB.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7folp.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        if ((0, $fHpHg.fg)('platform-design-system-inline-edit-reset-on-escape')) reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4EHpO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $bwpsq.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5uae8.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cBCgC.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4EHpO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $3c84accef102bc9e$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)($3c84accef102bc9e$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $3c84accef102bc9e$export$2e2bcd8739ae039 = $3c84accef102bc9e$var$InlineEdit;

});
parcelRegister("5uae8", function(module, exports) {

$parcel$export(module.exports, "default", () => $568f5c85371814cc$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $1Seuh = parcelRequire("1Seuh");

var $goMg1 = parcelRequire("goMg1");

var $gANiX = parcelRequire("gANiX");

var $dR8fb = parcelRequire("dR8fb");
const $568f5c85371814cc$var$buttonsContainerStyles = null;
const $568f5c85371814cc$var$buttonWrapperBaseStyles = null;
const $568f5c85371814cc$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dR8fb))), {
                            ...iconProps,
                            LEGACY_size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1Seuh.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gANiX))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($goMg1)))
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$568f5c85371814cc$export$2e2bcd8739ae039 = $568f5c85371814cc$var$Buttons;

});
parcelRegister("dR8fb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9db35ecad695c835ed46bfa4bbde0dff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1669ea74f05704f$var$_react = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a1669ea74f05704f$var$_checkMark = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("aiSXl")));

var $a1669ea74f05704f$var$_check = $a1669ea74f05704f$var$_interopRequireDefault((parcelRequire("2n32C")));
function $a1669ea74f05704f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1669ea74f05704f$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $a1669ea74f05704f$var$_react.default.createElement($a1669ea74f05704f$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $a1669ea74f05704f$var$_check.default
    }, props));
$a1669ea74f05704f$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $a1669ea74f05704f$var$_default = module.exports.default = $a1669ea74f05704f$var$CheckMarkIcon;

});
parcelRegister("2n32C", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1ba016b41382ba32$var$_react = $1ba016b41382ba32$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $983KX = parcelRequire("983KX");

var $1ba016b41382ba32$var$_checkMark = $1ba016b41382ba32$var$_interopRequireDefault((parcelRequire("dVU8x")));
function $1ba016b41382ba32$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ba016b41382ba32$var$CheckIcon = (props)=>/*#__PURE__*/ $1ba016b41382ba32$var$_react.default.createElement($983KX.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $1ba016b41382ba32$var$_checkMark.default
    }));
$1ba016b41382ba32$var$CheckIcon.displayName = 'CheckIcon';
var $1ba016b41382ba32$var$_default = module.exports.default = $1ba016b41382ba32$var$CheckIcon;

});



parcelRegister("1eXlh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac0118167eb799ed$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $ac0118167eb799ed$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $ac0118167eb799ed$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $ac0118167eb799ed$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $ac0118167eb799ed$export$2e2bcd8739ae039 = $ac0118167eb799ed$var$useButtonFocusHook;

});

parcelRegister("4P8zB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3969b97f38c61a8$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $7rJgC = parcelRequire("7rJgC");
const $a3969b97f38c61a8$var$readViewContainerStyles = null;
const $a3969b97f38c61a8$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $a3969b97f38c61a8$var$readViewWrapperStyles = null;
const $a3969b97f38c61a8$var$readViewFitContainerWidthStyles = null;
const $a3969b97f38c61a8$var$DRAG_THRESHOLD = 5;
const $a3969b97f38c61a8$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $a3969b97f38c61a8$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $a3969b97f38c61a8$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7rJgC.default), {
                xcss: $a3969b97f38c61a8$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3969b97f38c61a8$export$2e2bcd8739ae039 = $a3969b97f38c61a8$var$ReadView;

});


parcelRegister("69oHP", function(module, exports) {

$parcel$export(module.exports, "getFieldType", () => $53d3f894a8bd7ffe$export$b9089a6e41ed43aa);
$parcel$export(module.exports, "isRichTextSupported", () => $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1);


var $fOGZN = parcelRequire("fOGZN");

var $5fc53 = parcelRequire("5fc53");
const $53d3f894a8bd7ffe$var$atlassianSystemCFTypes = ()=>{
    const customSystemFields = (0, $fOGZN.specialFields)();
    return [
        ...(0, $fOGZN.customFieldsToDisplay)().filter((cf)=>!(0, $fOGZN.ecosystemCustomFields).includes(cf)),
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'SpecialFieldTypes'.
        ...Object.keys(customSystemFields).map((key)=>customSystemFields[key]),
        (0, $5fc53.FLAGGED_CF_TYPE)
    ];
};
const $53d3f894a8bd7ffe$export$f521834fc2bfcd81 = (custom)=>$53d3f894a8bd7ffe$var$atlassianSystemCFTypes().find((type)=>type === custom);
const $53d3f894a8bd7ffe$export$b9089a6e41ed43aa = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? $53d3f894a8bd7ffe$export$f521834fc2bfcd81(fieldSchema.custom) || fieldSchema.system || fieldSchema.type : undefined;
};
const $53d3f894a8bd7ffe$export$24d1b07fa0e9f9f1 = (field)=>{
    const fieldSchema = field ? field.schema : undefined;
    return fieldSchema ? fieldSchema.type === (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE) && fieldSchema.renderer === (0, $650578330a102f55$export$89b8c5d86c10a68c) || $53d3f894a8bd7ffe$export$b9089a6e41ed43aa(field) === (0, $5fc53.DESCRIPTION_TYPE) : false;
};

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';


parcelRegister("cIZbf", function(module, exports) {

$parcel$export(module.exports, "getFieldIdFromAri", () => $9b276216fa1bf039$export$4ae913a052c0d582);
$parcel$export(module.exports, "getPriorityIdFromAri", () => $9b276216fa1bf039$export$d3f3dc1a70aa9a8);
$parcel$export(module.exports, "getUserIdFromAri", () => $9b276216fa1bf039$export$364d97890ac491af);
const $9b276216fa1bf039$var$FIELD_ID_ARI_REGEX = /ari:cloud:jira:.*?:issuefieldvalue\/.*?\/(.*)/;
const $9b276216fa1bf039$var$PRIORITY_ID_ARI_REGEX = /ari:cloud:jira:.*?:priority\/activation\/.*?\/(.*)/;
const $9b276216fa1bf039$var$USER_ID_ARI_REGEX = /ari:cloud:identity::user\/(.*)/;
const $9b276216fa1bf039$export$4ae913a052c0d582 = (fieldIdOrAri)=>{
    const match = fieldIdOrAri?.match($9b276216fa1bf039$var$FIELD_ID_ARI_REGEX);
    return match ? match[1] : fieldIdOrAri;
};
const $9b276216fa1bf039$export$d3f3dc1a70aa9a8 = (priorityIdOrAri)=>{
    const match = priorityIdOrAri?.match($9b276216fa1bf039$var$PRIORITY_ID_ARI_REGEX);
    return match ? match[1] : priorityIdOrAri;
};
const $9b276216fa1bf039$export$364d97890ac491af = (userIdOrAri)=>{
    const match = userIdOrAri?.match($9b276216fa1bf039$var$USER_ID_ARI_REGEX);
    return match ? match[1] : userIdOrAri;
};

});


const $ea286d2db1e9f268$export$195635d59130784a = 'issue-field-number.ui.issue-field-number';
const $ea286d2db1e9f268$export$5dadcbcc34de35f = 'issue-field-number.ui.issue-field-number--container';
const $ea286d2db1e9f268$export$ddb0dcfa9074309f = 'issue-field-number.ui.badge';
const $ea286d2db1e9f268$export$3cb3b73ace5de3d1 = `${$ea286d2db1e9f268$export$ddb0dcfa9074309f}-hover-container`;
const $ea286d2db1e9f268$export$ac421571f56485b8 = 'issue-field-number.edit.warning-icon';

const $a4c5fe4dcf7753af$export$1ff9623b26415f8 = 'INLINE';
const $a4c5fe4dcf7753af$export$44f42916442b37c3 = 'LOZENGE';
const $a4c5fe4dcf7753af$export$eade6b6091579183 = 'NORMAL';
const $a4c5fe4dcf7753af$export$797ed91ebb8db1c5 = 'CHILD_ISSUE_LOZENGE';

parcelRegister("3wves", function(module, exports) {

$parcel$export(module.exports, "useNumberField", () => $b5136d35d41d8f83$export$23f548e970bdf099);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");
const $b5136d35d41d8f83$export$23f548e970bdf099 = ({ issueKey: issueKey, fieldKey: fieldKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, saveField: saveField })=>{
    // useFieldConfig now returns an object { value, loading } instead of just the fieldConfig value
    // if possible when touching this, try and refactor to pass the new object instead of just the value
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, fieldKey);
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', 'number');
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: fieldKey,
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        saveField: saveField
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});

parcelRegister("bpos5", function(module, exports) {

$parcel$export(module.exports, "NumberEdit", () => $12fa5d85913595d1$export$a902121087114074);

var $5uXOq = parcelRequire("5uXOq");

var $85eFT = parcelRequire("85eFT");

var $0yZbT = parcelRequire("0yZbT");
var $2s57o = parcelRequire("2s57o");

var $9r7BT = parcelRequire("9r7BT");

var $koVbs = parcelRequire("koVbs");


var $ij436 = parcelRequire("ij436");
const $12fa5d85913595d1$export$a902121087114074 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { isInvalid: isInvalid = false, type: type, defaultValue: defaultValue, ...rest } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const value = defaultValue === null ? '' : Number(defaultValue);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
        xcss: $12fa5d85913595d1$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9r7BT.default), {
        isCompact: true,
        "aria-label": formatMessage((0, $ij436.default).accessibleLabel),
        isInvalid: isInvalid,
        type: type,
        value: value,
        step: "any",
        autoFocus: true,
        elemAfterInput: isInvalid === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $0yZbT.default), {
            xcss: $12fa5d85913595d1$var$warningWrapperStyles,
            testId: (0, $ea286d2db1e9f268$export$ac421571f56485b8)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($85eFT))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            color: "var(--ds-icon-warning, #E56910)",
            label: ""
        })) : null,
        ...rest
    }));
});
const $12fa5d85913595d1$var$containerStyles = (0, $2s57o.xcss)({
    width: '100%',
    cursor: 'auto'
});
const $12fa5d85913595d1$var$warningWrapperStyles = (0, $2s57o.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.050'
});

});
parcelRegister("ij436", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e7c50ba285366a8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0e7c50ba285366a8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorTitle: {
        "id": "issue-field-number.error-title",
        "defaultMessage": "We couldn't set the story point value"
    },
    errorMessage: {
        "id": "issue-field-number.error-message",
        "defaultMessage": "You can try again in a few minutes, or refresh the page."
    },
    accessibleLabel: {
        "id": "issue-field-number.accessible-label",
        "defaultMessage": "Enter story point estimate"
    }
});

});





//# sourceMappingURL=async-issue-field-number.165acbb4.js.map
